import { SVGProps, Ref, forwardRef } from "react";

const PinIcon = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 18 18"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Pin Icon"
    {...props}
  >
    <title id="Pin Icon">Pin Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.67}
      d="M5.549 11.994.835 16.708M8.314 4.515l-1.301 1.3c-.106.107-.16.16-.22.202a.833.833 0 0 1-.172.092 1.701 1.701 0 0 1-.29.071l-3.053.611c-.794.159-1.19.238-1.376.447a.833.833 0 0 0-.202.668c.038.277.324.563.897 1.135L8.5 14.946c.573.572.859.859 1.136.897a.833.833 0 0 0 .667-.202c.21-.186.289-.582.448-1.376l.61-3.054c.03-.147.045-.22.072-.29a.833.833 0 0 1 .092-.171c.042-.061.095-.114.201-.22l1.3-1.3a1.66 1.66 0 0 1 .14-.132.836.836 0 0 1 .105-.071c.041-.024.085-.043.173-.08l2.079-.891c.606-.26.91-.39 1.047-.6a.834.834 0 0 0 .12-.623c-.05-.246-.283-.48-.75-.946l-4.285-4.286c-.467-.466-.7-.7-.946-.75a.833.833 0 0 0-.623.12c-.21.138-.34.441-.6 1.048l-.89 2.079c-.038.088-.057.132-.08.173a.834.834 0 0 1-.072.105c-.03.037-.063.071-.131.14Z"
    />
  </svg>
);

const ForwardRef = forwardRef(PinIcon);
export default ForwardRef;
